import { useQuery } from '@tanstack/react-query';
import { getTaxSettings, TaxSettings } from '../../../api/TaxSettings/taxSettings';

export function useGetTaxSettings() {
  const getQuery = useQuery({
    queryKey: [ 'getTaxSettings' ],
    queryFn: () => getTaxSettings()
  });

  return {
    data: (getQuery.data?.data.results as TaxSettings) || null,
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
    refetch: getQuery.refetch
  };
}
